export class ReviewDriverBreakEntity {
  startAt?: Date | string | null
  endAt?: Date | string | null
  reviewNotes?: string | null
}
